<template>
  <div class="order-placed-component wizard-content">
    <h1 class="title-done mx-auto text-center">
      {{ trans.get('wizard.congrats') }}
    </h1>
    <div class="done-section flex flex-col space-y-5 lg:flex-row lg:space-y-0">
      <div class="section-item">
        <p>{{ trans.get('wizard.orderNumber') }}</p>
        <p>{{ order.code }}</p>
      </div>
      <div class="section-item">
        <p>{{ trans.get('wizard.expectedDeliveryDate') }}</p>
        <p v-html="shippingDesc"></p>
      </div>
      <div class="section-item">
        <p>{{ trans.get('wizard.shipping') }}</p>
        <p>{{ shippingName }}</p>
      </div>
    </div>

    <div class="done-section flex flex-col space-y-5 lg:flex-row lg:space-y-0">
      <div class="section-item">
        <p>{{ trans.get('wizard.contactData') }}:</p>
        <div>
          <p>{{ addressData.personal.name.value }} {{ addressData.personal.surname.value }}</p>
          <p>{{ personalData.email.value }}</p>
          <p>{{ personalData.phone_prefix.value}} {{ personalData.phone.value }}</p>
        </div>
      </div>
      <div class="section-item">
        <p>{{ trans.get('wizard.addressTitle') }}</p>
        <div>
          <p>{{ fullAddress[0] }}</p>
          <p>{{ fullAddress[1] }}</p>
          <p>{{ fullAddress[2] }}</p>
        </div>
      </div>
    </div>

    <div class="pay-section border-title">
      <div class="pay-section-item">
        <p>{{ trans.get('wizard.paymentMethod') }}:</p>
      </div>
      <div class="pay-image-done">
        <p>{{ paymentDesc }}</p>
        <!-- <p>Card name</p>
                <p>Numero tarjeta: **** **** **** 1234</p>
                <p>validez: Validez card</p> -->
      </div>
      <div
        v-if="order.payment_method == 'transfer'"
        class="transfer-extra-info"
      >
        <div class="section">
          <span class="title">{{
            trans.get('wizard.transfer_extra.account_holder')
          }}</span>
          <img src='/img/icons/company.svg' alt='image-1' style='display:inline-block;' width='140' height='auto' loading='lazy'>
        </div>
        <div class="section">
          <span class="title">{{
            trans.get('wizard.transfer_extra.account_number')
          }}</span>
          <span class="text">ES31 3025 0012 1414 0012 6489</span>
        </div>
        <div class="section">
          <span class="title">{{ trans.get('wizard.transfer_extra.bic_entity') }}</span>
          <span class="text">CDENESBBXXX:</span>
        </div>
        <div class="section">
          <span class="title">{{ trans.get('wizard.transfer_extra.concept') }}</span>
          <span class="text">{{ order.code }}</span>
        </div>
        <div class="section">
          <span class="warning">{{ trans.get('wizard.transfer_extra.warning') }}</span>
        </div>
      </div>
    </div>

    <div class="pay-section">
      <div class="grid-products">
        <p class="font-bold">{{ trans.get('wizard.article') }}</p>
        <p class="font-bold text-center">{{ trans.get('wizard.units') }}</p>
        <p class="font-bold text-right">{{ trans.get('wizard.price') }}</p>
        <template v-for="product in order.products">
          <div class="image-done section-product" :key="product.id">
            <picture>
                <source :srcset="product.images[0]?.webp || '/img/no-image-placeholder.png'" type="image/webp">
                <img
                class="hidden md:inline mr-5"
                :src="product.images[0]?.original || '/img/no-image-placeholder.png'"
                :alt="product.pivot.product_name[lang] || product.pivot.product_name.en"
                />
            </picture>
            <p>{{ product.pivot.product_name[lang] || product.pivot.product_name.en }}</p>
          </div>
          <div class="section-product text-center" :key="product.id">
            <p>{{ product.pivot.quantity }}</p>
          </div>
          <div class="section-product ml-auto" :key="product.id">
            <p class="text-right">
              {{ product.pivot.price | currency }}
              <span v-if="product.has_any_active_discount || (order.coupon_name && order.coupon_type != 'freesend')" class="line-through text-inactive-grey text-sm">{{ product.pivot.original_price  | currency }}</span>
            </p>
        </div>
        <div v-if="product.pivot.promotion_text" class="col-start-1 col-end-4">
            <promotion-card class="flex items-center justify-between mt-2 bg-light-white text-secondary font-bold p-3" :promotion-description="product.pivot.promotion_text[lang]" :promotion-image="product.pivot.promotion_image" :promotion-info="promotionInfo(product.pivot.promotion_discount)" show-image></promotion-card>
        </div>
        </template>
      </div>
    </div>

    <div class="resume rounded p-4 md:p-8 mt-8">
      <div class="flex justify-between mb-2">
        <span>{{ trans.get('wizard.subtotal') }}</span>
        <span>{{ order.subtotal | currency }}</span>
      </div>
      <div v-if="order.coupon_name" class="flex justify-between mb-2">
        <span>{{ trans.get('wizard.coupon') }}</span>
        <span v-if="order.coupon_type === 'freesend'">{{trans.get('wizard.shipping')}} {{ trans.get('wizard.free') }}</span>
        <span v-else>{{order.discount | currency }}</span>
      </div>
      <div class="flex justify-between mb-2">
        <span>{{ trans.get('wizard.shippingPrice') }}</span>
        <span>
          {{
            parseInt(order.shipping_price) == 0
              ? trans.get('wizard.free')
              : order.shipping_price | currency
          }}
        </span>
      </div>
      <div class="flex justify-between">
        <span class="font-bold">{{ trans.get('wizard.totalIvaIncluded') }}</span>
        <span class="font-bold">
          {{ order.total | currency }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  GET_ADDRESS_DATA,
  GET_ORDER,
  GET_PERSONAL_DATA,
  RETREIVE_ORDER_ACTION,
} from "../../../store/wizard/types";
import { GET_COUPON } from "../../../store/cart/types";
import mixin from "../../../mixin";
import PromotionCard from "../../cards/PromotionCard.vue";

export default {
  components: {
    PromotionCard
  },
  mixins: [mixin],
  computed: {
    ...mapGetters({
      addressData: GET_ADDRESS_DATA,
      order: GET_ORDER,
      personalData: GET_PERSONAL_DATA,
      coupon: GET_COUPON,
    }),
    shippingName() {
      return this.trans.get('wizard.standardShippingName');
    },
    shippingDesc() {
      return this.trans.get('wizard.standardShippingDesc');
    },
    fullAddress() {
      const { address, city, info } = this.addressData.personal;
      const { country, postal } = this.addressData;
      return [
        `${address.value} ${info.value}`,
        `${postal.value}, ${city.value}, ${country.value}`,
      ];
    },
    paymentDesc() {
      let text = "";

      switch (this.order.payment_method) {
        case "payland":
          text = this.trans.get('wizard.creditCard');
          break;
        case "bitcoin":
          text = this.trans.get('wizard.bitcoin');
          break;
        case "transfer":
          text = this.trans.get('wizard.transfer');
          break;
        default:
          text = this.trans.get('wizard.creditCard');
          break;
      }

      return text;
    },
  },
  methods: {
    ...mapActions({
      retreiveOrder: RETREIVE_ORDER_ACTION,
    }),
    handleOnCreated() {
      if (this.order.id == 0) {
        this.retreiveOrder(this.$route.params.order_code);
      }
    },
    promotionInfo(discount){
        if(!discount) return this.trans.get('wizard.free');

        return '- ' + discount + '%';
    }
  },
  created() {
    this.handleOnCreated();
  },
};
</script>

<style lang="scss" scoped>
.order-placed-component {
  display: flex;
  flex-direction: column;
  max-width: 1000px;
  width: 100%;
  padding-bottom: 1rem;

  p {
    margin-bottom: 0.75rem;
  }
  .title-done {
    font-size: 25px;
    margin-bottom: 50px;
  }
  .done-section,
  .pay-section,
  .resume {
    align-self: stretch;
  }
  .pay-section {
    display: flex;
    flex-direction: column;
    padding: 30px 0px;
    &-item {
      display: flex;
      flex-direction: row;
      p {
        width: 33%;
        font-weight: bold;
        @media (max-width: 1023px) {
          width: 100%;
        }
      }
    }
    .pay-image-done {
      display: flex;
      flex-direction: row;
      @media (max-width: 1023px) {
        flex-direction: column;
      }
      img {
        width: 50px;
      }
      p {
        margin: 0px;
        &:not(:first-child) {
          padding-left: 20px;
        }
      }
    }
    .image-done {
      display: flex;
      flex-direction: row;
      align-items: center;

      img {
        width: 50px;
        height: 50px;
        object-fit: contain;
      }
      p {
        margin: 0px;
      }
    }
    .section-product-item {
      display: flex;
      flex-direction: row;

      .section-product {
        width: 33%;
        align-self: center;
        @media (max-width: 1023px) {
          img {
            width: 30px;
          }
        }
        p {
          margin: 0px;
        }
      }
    }
  }
  .border-product {
    border-bottom: 0.5px solid rgba(61, 61, 61, 0.5);
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
  }
  .done-section {
    border-bottom: 1px solid black;
    padding: 30px 0px;

    &:first-of-type {
      @media (max-width: 1023px) {
        padding-top: 1rem;
      }
    }
    .section-item {
      width: 33%;
      display: flex;
      flex-direction: column;
      padding-right: 20px;
      @media (max-width: 1023px) {
        width: 100%;
      }
      > p:first-child {
        font-weight: bold;
      }
      > div p {
        margin-bottom: 0.5rem;
      }
    }
  }
  .resume {
    background: #3a473c;
    color: white;
  }
  .grid-products {
    display: grid;
    grid-template-columns: 40% 5rem 1fr;
    column-gap: 1rem;
    row-gap: 0.5rem;
    align-items: center;
    @media (min-width: 640px) {
      grid-template-columns: 33% 5rem 1fr;
    }
    > div p {
      margin-bottom: 0;
    }
  }
}
</style>
